import React from "react";
import "./CeoReport.scss";
import ceoImg from "../../../assets/About/rupali-ceo.jpeg";
// import ceoSign from "../../../assets/About/ceo-sign.PNG";
import ceoSign from "../../../assets/About/ceo-sign.png";

const CeoReport = () => {
  return (
    <>
      <div className="ceo_report">
        <div className="container">
          <div className="heading_box">CEO's Round up</div>

          <div className="row">
            <div className="col-lg-8 ">
              <p>
                Ladies and Gentlemen, Esteemed Shareholders, and Valued
                Partners, <br />
                It is with great honour and optimism that I present to you the
                Annual Report of Rupali Insurance Company Limited for the year
                ending December 31, 2024.
              </p>
              <p>
                <b>Resilience with Vision, Growth with Purpose</b>
                <br />
                This has been a year of profound transformation globally,
                nationally, and within our own organisation. Through strategic
                clarity, operational discipline, and a forward-looking mindset,
                we not only navigated a turbulent environment but also laid the
                groundwork for sustainable growth and innovation in the years
                ahead.
              </p>
              <p>
                <b>Global Insurance Landscape – A World in Transition</b>
                <br />
                In 2024, the global general insurance industry continued to
                evolve against a backdrop of economic realignments,
                climate-related risks, and geopolitical complexity. Insurers
                across regions accelerated investment in digital platforms,
                artificial intelligence, and automation, driving enhanced
                customer experiences and operational agility.
              </p>
              <p>
                A growing emphasis on ESG-aligned practices also reshaped
                underwriting and investment strategies. Meanwhile, the rising
                prominence of cybersecurity and data governance led to deeper
                collaboration between traditional insurers and InsurTechs
                creating more responsive and inclusive insurance ecosystems.
                <br />
                <br />
                These developments signal a decisive shift towards a more
                personalised, tech-driven, and risk-intelligent global insurance
                environment, and we at Rupali Insurance are fully committed to
                aligning ourselves with this future.
              </p>
            </div>
            <div className="col-lg-4 text-lg-end text-center order-first order-lg-last">
              <img src={ceoImg} className="img-fluid mb-3" alt="" />
            </div>
          </div>

          <div className="my-3">
            <p>
              <b>National Outlook Rising Above Uncertainty </b>
              <br />
              Bangladesh’s general insurance sector in 2024 operated amidst
              historic socio-political shifts. The July Revolution stood as a
              defining moment in our national journey reigniting aspirations for
              justice, democracy, and equitable progress. As a responsible
              corporate citizen, Rupali Insurance stands in solidarity with
              these ideals, while respectfully honouring those whose sacrifices
              have shaped our collective conscience.
              <br />
              <br />
              Amid this transition, our industry showed resilience. As insurers,
              we continued to play a vital role in risk mitigation, financial
              inclusion, and institutional trust-building. Regulatory reforms,
              the advent of bancassurance, and expanding awareness of risk
              solutions have created new possibilities for deeper outreach and
              impact.
            </p>

            <p>
              <b>Performance Overview – Delivering with Discipline</b>
              <br />
              In this environment, Rupali Insurance has delivered a performance
              that reflects stability, prudence, and ambition. Key highlights
              include:
            </p>
            <p>
              <ul>
                <li>
                  <b>Gross Premium Income:</b> BDT 673.16 million, up 14.26%
                  from the previous year
                </li>
                <li>
                  <b>Net Profit Before Tax:</b> BDT 127.7 million, a 158.9%
                  increase, driven by robust investment returns and operational
                  efficiency
                </li>
                <li>
                  <b>Underwriting Profit:</b> BDT 28.16 million
                </li>
                <li>
                  <b>Total Assets:</b> BDT 2,653.83 million, with BDT 917.43
                  million invested and BDT 440.91 million in fixed assets
                </li>
                <li>
                  <b>Workforce & Reach:</b> Expanded to 36 branches and a team
                  of 413 committed professionals
                </li>
              </ul>
            </p>
            <p>
              These numbers are not merely financial achievements they reflect
              our evolving capability to serve, support, and safeguard our
              policyholders and stakeholders through every economic cycle.
            </p>

            <p>
              <b>Business Segment Insights – Strength Rooted in Strategy</b>
              <br />
              <ul>
                <li>
                  Fire Insurance delivered exceptional results, with
                  underwriting profit soaring to BDT 7.77 million, thanks to
                  improved pricing strategies and better risk calibration,
                  especially in SME and commercial segments.
                </li>
                <li>
                  Marine Insurance, despite being affected by global trade
                  headwinds and currency volatility, sustained stability,
                  generating BDT 8.82 million in underwriting profit on a gross
                  premium of BDT 279.18 million.
                </li>
                <li>
                  Motor and Miscellaneous Insurance remained steady, though
                  relatively flat, due in part to regulatory enforcement
                  challenges in the third-party motor space. We remain
                  optimistic that new directives will support revitalisation in
                  this area.
                </li>
              </ul>
            </p>

            <p>
              <b>Strategic Outlook – Building a Future-Ready Insurer</b>
              <br />
              Looking ahead, our focus is on building a more resilient,
              digitally enabled, and innovation-driven Rupali Insurance. Key
              strategic priorities include:
              <ul>
                <li>
                  <b>Bancassurance Integration:</b> We are preparing to launch
                  bancassurance solutions in collaboration with leading
                  banks—providing easier, more trusted access to risk protection
                  for a wider range of customers.
                </li>
                <li>
                  <b>Digital Acceleration: </b> We are investing in core
                  automation, analytics, and smart underwriting platforms to
                  improve service delivery, reduce turnaround time, and deepen
                  customer engagement.
                </li>
                <li>
                  <b>Governance & Risk Culture:</b> We are elevating our
                  internal audit systems, enhancing compliance protocols, and
                  aligning closely with evolving IDRA directives to ensure
                  transparency and resilience.
                </li>
                <li>
                  <b>Customer Trust & Claims Excellence:</b> We are placing
                  renewed emphasis on proactive claims management, with a
                  customer-first approach, faster resolution, and improved
                  tracking transparency.
                </li>
              </ul>
            </p>
            <p>
              <b>Closing Thoughts – Commitment to Progress</b>
              The year 2024 has reminded us that true progress is born not in
              stability, but in our ability to transform during uncertainty. At
              Rupali Insurance, we are proud of how far we have come and even
              more inspired by where we are going.
            </p>
            <p>
              We remain deeply committed to contributing to the vision of a
              progressive, inclusive, and economically vibrant Bangladesh. Our
              role as a general insurer is not merely to underwrite risk, but to
              unlock confidence for businesses, families, and the nation at
              large.
            </p>
            <p>
              I extend my heartfelt thanks to our Board of Directors for their
              guidance, to our exceptional employees across all 36 branches for
              their integrity and service, and to our clients, shareholders, and
              regulatory partners for their enduring trust and support.
            </p>
            <p>
              Together, we move forward with confidence in our strategy, belief
              in our people, and purpose in our journey.
            </p>
          </div>

          {/*  */}

          <p>
            Thanking you with
            <br />
            Kindest Regards,
          </p>
          <p>
            <b>A. H. M. Abul Khair</b> <br />
            Chief Executive Officer (In-charge)
          </p>

          {/* <div className="text-lg-end text-center">
            <img src={ceoSign} className="img-fluid" alt="" />
          </div> */}
        </div>
      </div>
    </>
  );
};

export default CeoReport;
